module.exports = __webpack_public_path__ + "img/solana-light.aff07c3e.svg";